import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  private dialogState = new BehaviorSubject<{ visible: boolean, title: string, message: string, type:string }>({
    visible: false,
    title: 'Подтверждение',
    message: 'Вы уверены?',
    type: 'delete'
  });
  private responseSubject = new Subject<boolean>();

  private _showRejectInput$ = new BehaviorSubject<boolean>(false);
  showRejectInput$ = this._showRejectInput$.asObservable();

  openDialog(title: string, message: string, type: string): Observable<boolean> {
    this.responseSubject = new Subject<boolean>();
    this.dialogState.next({ visible: true, title, message, type });
    return this.responseSubject.asObservable();
  }

  closeDialog(): void {
    this.dialogState.next({ visible: false, title: '', message: '', type:''});
  }

  confirm(): void {
    this.responseSubject.next(true);
    this.responseSubject.complete();
    this.closeDialog();
  }

  cancel(): void {
    this.responseSubject.next(false);
    this.responseSubject.complete();
    this.closeDialog();
  }


  getDialogState() {
    return this.dialogState.asObservable();
  }
}
